import { useLocation } from "react-router-dom";
import { LodgedPackages } from "pages/lodged-packages";
export const LodgedPackagesWrapper = () => {
    const location = useLocation();
    return <LodgedPackages key={location.key} />;
};
